class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newGrid = doc.getElementById('product-grid');
    const currentGrid = document.getElementById('product-grid');
    if (newGrid && currentGrid) {
      currentGrid.outerHTML = newGrid.outerHTML;
    } else {
      // Fallback: replace the entire container if UL not found
      const newContainer = doc.getElementById('ProductGridContainer');
      const container = document.getElementById('ProductGridContainer');
      if (newContainer && container) container.innerHTML = newContainer.innerHTML;
    }

    // Update pagination wrapper
    const containerEl = document.getElementById('ProductGridContainer');
    if (containerEl) {
      const newPagination = doc.querySelector('.pagination-wrapper.page-width');
      const currentPagination = containerEl.querySelector('.pagination-wrapper.page-width');

      if (newPagination && currentPagination) {
        currentPagination.outerHTML = newPagination.outerHTML;
      } else if (newPagination && !currentPagination) {
        const gridEl = containerEl.querySelector('#product-grid');
        if (gridEl) gridEl.insertAdjacentElement('afterend', newPagination);
      } else if (!newPagination && currentPagination) {
        currentPagination.remove();
      }
    }

    // Cancel scroll-trigger animations on new nodes
    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      gridContainer.querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    }

    // Re-init sliders if needed
    const sliders = document.querySelectorAll('product-card-slider');
    sliders.forEach((slider) => {
      if (typeof slider.init === 'function' && !slider.initialized) {
        try {
          slider.init();
        } catch (_) {}
      }
    });
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const parsedCountEl = parsed.getElementById('ProductCount') || parsed.getElementById('ProductCountDesktop');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    // Custom PLP desktop count element
    const parsedPlpCount = parsed.querySelector('.plp-product-count');
    const currentPlpCount = document.querySelector('.plp-product-count');

    if (parsedCountEl && (container || containerDesktop)) {
      const count = parsedCountEl.innerHTML;
      if (container) {
        container.innerHTML = count;
        container.classList.remove('loading');
      }
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }
    // Update custom PLP product count on desktop bar
    if (parsedPlpCount && currentPlpCount) {
      currentPlpCount.innerHTML = parsedPlpCount.innerHTML;
    }

    // Update Filters toggle with APPLIED FILTERS count (not products count): show (>0) as (n), else hide
    const filterToggleRoots = document.querySelectorAll('.plp-filters-toggle');
    if (filterToggleRoots.length) {
      // Count active facets from the fetched HTML (desktop and mobile active chips)
      const activeChips = parsed.querySelectorAll(
        '.active-facets-desktop .active-facets__button, .active-facets-mobile .active-facets__button'
      );
      const appliedCount = activeChips ? activeChips.length : 0;
      filterToggleRoots.forEach((root) => {
        let countEl = root.querySelector('.plp-filters-count');
        if (appliedCount > 0) {
          if (!countEl) {
            countEl = document.createElement('span');
            countEl.className = 'plp-filters-count';
            // insert before icon if exists, else at end
            const icon = root.querySelector('.plp-filters-icon');
            if (icon) {
              root.insertBefore(countEl, icon);
            } else {
              root.appendChild(countEl);
            }
          }
          countEl.textContent = `(${appliedCount})`;
          countEl.style.display = '';
        } else if (countEl) {
          countEl.textContent = '';
          countEl.style.display = 'none';
        }
      });
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // Replace the entire desktop facets wrapper from Section Rendering API
    const newDesktopWrapper = parsedHTML.getElementById('FacetsWrapperDesktop');
    const currentDesktopWrapper = document.getElementById('FacetsWrapperDesktop');
    if (newDesktopWrapper && currentDesktopWrapper) {
      currentDesktopWrapper.outerHTML = newDesktopWrapper.outerHTML;
      try {
        const ff = document.querySelector('facet-filters-form');
        const wrapper = ff ? ff.querySelector('#FacetsWrapperDesktop') : null;
        if (wrapper && typeof onKeyUpEscape === 'function') wrapper.addEventListener('keyup', onKeyUpEscape);
      } catch (e) {}
    }

    // Replace the entire mobile facets wrapper if present
    const newMobileWrapper = parsedHTML.getElementById('FacetsWrapperMobile');
    const currentMobileWrapper = document.getElementById('FacetsWrapperMobile');
    if (newMobileWrapper && currentMobileWrapper) {
      currentMobileWrapper.outerHTML = newMobileWrapper.outerHTML;
    }

    // Update active facets and auxiliary elements
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // Sync swatch UI state for color filters and bind listeners for instant feedback
    FacetFiltersForm.syncColorSwatches();
    // Sync generic checkbox UI for mobile facets (show ring and dot immediately on selection)
    FacetFiltersForm.syncMobileFacetCheckboxesUI();
    
    // Реініціалізуємо Apply кнопки в filters drawer
    FacetFiltersForm.reinitDrawerButtons();

    // Focus behaviour on the toggled filter (optional, keep parity with previous UX)
    if (event) {
      const jsFilter = event.target && event.target.closest ? event.target.closest('.js-filter') : null;
      if (jsFilter) {
        const newFacetDetailsElement = document.getElementById(jsFilter.id);
        if (newFacetDetailsElement) {
          const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
          const isTextInput = event.target.getAttribute && event.target.getAttribute('type') === 'text';
          if (newElementToActivate && !isTextInput) newElementToActivate.focus();
        }
      }
    }
  }
  
  static reinitDrawerButtons() {
    const filtersDrawer = document.getElementById('filtersDrawer');
    if (!filtersDrawer) return;
    
    // Реініціалізуємо кнопки Apply на всіх пристроях
    const applyButtons = filtersDrawer.querySelectorAll('button[type="button"].button--primary');
    applyButtons.forEach(function(btn) {
      // Видаляємо старі onclick атрибути
      btn.removeAttribute('onclick');
      // Створюємо новий обробник
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        // Застосувати всі вибрані фільтри з мобільної форми одним запитом
        const mobileForm = document.getElementById('FacetFiltersFormMobile');
        if (mobileForm) {
          const formData = new FormData(mobileForm);
          const searchParams = new URLSearchParams(formData).toString();
          FacetFiltersForm.renderPage(searchParams, null, true);
        }
        // Закрити дровер і розблокувати скролл на мобільних
        filtersDrawer.classList.remove('active');
        if (window.innerWidth <= 1024) {
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      });
    });

    // Clear All у футері мобільних фільтрів: закриваємо дровер після кліку
    const clearAllLinks = filtersDrawer.querySelectorAll('.mobile-facets__footer .mobile-facets__clear');
    clearAllLinks.forEach(function(link) {
      const newLink = link.cloneNode(true);
      link.parentNode.replaceChild(newLink, link);
      newLink.addEventListener('click', function() {
        // Не перериваємо нативну логіку facet-remove; просто закриваємо дровер
        filtersDrawer.classList.remove('active');
        if (window.innerWidth <= 1024) {
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      });
    });
    
    // Реініціалізуємо кнопки Close в header
    const mobileCloseButtons = filtersDrawer.querySelectorAll('.plp-filters-drawer__close');
    mobileCloseButtons.forEach(function(btn) {
      // Створюємо новий обробник
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        filtersDrawer.classList.remove('active');
        // Розблокування прокрутки (тільки на мобільних)
        if (window.innerWidth <= 1024) {
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      });
    });
    
    // Клік по всьому header (тільки desktop) закриває drawer
    const desktopHeaderClosers = filtersDrawer.querySelectorAll('.plp-filters-drawer__header');
    desktopHeaderClosers.forEach(function(el) {
      const newEl = el.cloneNode(true);
      el.parentNode.replaceChild(newEl, el);
      newEl.addEventListener('click', function(e) {
        if (window.innerWidth <= 1024) return; // тільки для desktop
        e.preventDefault();
        e.stopPropagation();
        filtersDrawer.classList.remove('active');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      });
    });

    // Закриття drawer по кліку на заголовок "Close" (тільки мобільні)
    const desktopTitleClosers = filtersDrawer.querySelectorAll('.plp-filters-drawer__title--desktop');
    desktopTitleClosers.forEach(function(el) {
      const newEl = el.cloneNode(true);
      el.parentNode.replaceChild(newEl, el);
      
      newEl.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // Закриваємо drawer завжди; скролл розблоковуємо тільки на мобільних
        filtersDrawer.classList.remove('active');
        if (window.innerWidth <= 1024) {
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      });
    });
    
    // Делегований обробник на весь дровер для надійності (після re-render)
    if (!filtersDrawer.__titleDelegated) {
      filtersDrawer.addEventListener('click', function(e) {
        const closer = e.target && e.target.closest ? e.target.closest('.plp-filters-drawer__title--desktop') : null;
        if (!closer) return;
        e.preventDefault();
        e.stopPropagation();
        filtersDrawer.classList.remove('active');
        if (window.innerWidth <= 1024) {
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      });
      filtersDrawer.__titleDelegated = true;
    }
    
    // Реініціалізуємо details елементи (тільки на мобільних)
    if (window.innerWidth <= 1024) {
      FacetFiltersForm.reinitDrawerDetails();
    }
  }
  
  static reinitDrawerDetails() {
    const filtersDrawer = document.getElementById('filtersDrawer');
    if (!filtersDrawer) return;
    
    const mobileDetails = filtersDrawer.querySelectorAll('.mobile-facets__details');
    
    mobileDetails.forEach(function(detail) {
      const summary = detail.querySelector('.mobile-facets__summary');
      const closeButton = detail.querySelector('.mobile-facets__close-button');
      
      if (!summary) return;
      
      // Видаляємо старі обробники через клонування
      const newSummary = summary.cloneNode(true);
      summary.parentNode.replaceChild(newSummary, summary);
      
      // Дозволяємо нативну поведінку details/summary і керуємо класом для анімації
      newSummary.addEventListener('click', function() {
        // Оновлюємо aria-expanded та клас анімації після зміни стану
        setTimeout(function() {
          const isOpen = detail.hasAttribute('open');
          newSummary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          if (isOpen) {
            detail.classList.add('menu-opening');
          } else {
            detail.classList.remove('menu-opening');
          }
          // Toggle plus/minus icons within summary
          const plusIcon = newSummary.querySelector('.mobile-facets__icon-plus');
          const minusIcon = newSummary.querySelector('.mobile-facets__icon-minus');
          if (plusIcon && minusIcon) {
            plusIcon.style.display = isOpen ? 'none' : 'inline-flex';
            minusIcon.style.display = isOpen ? 'inline-flex' : 'none';
          }
        }, 10);
      });
      
      // Обробка кліку на close button для повернення назад
      if (closeButton) {
        const newCloseButton = closeButton.cloneNode(true);
        closeButton.parentNode.replaceChild(newCloseButton, closeButton);
        
        newCloseButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          detail.removeAttribute('open');
          newSummary.setAttribute('aria-expanded', 'false');
          detail.classList.remove('menu-opening');
        });
      }
    });
  }

  static syncColorSwatches() {
    const colorSelectors = [
      '#FacetsWrapperDesktop .facets__filter--colors',
      '#FacetsWrapperMobile .mobile-facets__details--colors',
    ];

    const containers = Array.from(document.querySelectorAll(colorSelectors.join(', ')));
    if (!containers.length) return;

    const applyState = (container) => {
      // Desktop: labels with checkbox or swatch-input
      container.querySelectorAll('label.facets__label, .swatch-input-wrapper').forEach((el) => {
        const input = el.querySelector('input[type="checkbox"], input.swatch-input__input');
        if (!input) return;
        const label = el.classList.contains('facets__label') ? el : el.closest('.facets__label') || el;
        if (!label) return;
        label.classList.toggle('active', Boolean(input.checked));
        label.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      });
    };

    containers.forEach((c) => applyState(c));

    // Delegate change handlers for instant visual feedback
    containers.forEach((container) => {
      if (container.__swatchBound) return; // avoid rebinding
      container.addEventListener('change', (e) => {
        const target = e.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.type !== 'checkbox') return;
        const wrapper = target.closest('.facets__label, .swatch-input-wrapper, .mobile-facets__label');
        if (wrapper) {
          const label = wrapper.classList.contains('facets__label') ? wrapper : wrapper.closest('.facets__label') || wrapper;
          if (label) {
            label.classList.toggle('active', target.checked);
            label.setAttribute('aria-pressed', target.checked ? 'true' : 'false');
          }
        }
      });
      container.__swatchBound = true;
    });
  }

  // Вирівнює візуал чекбоксів мобільних фільтрів із десктопом: порожнє кільце (не вибрано) / кільце з чорною крапкою (вибрано)
  static syncMobileFacetCheckboxesUI() {
    const mobileLists = document.querySelectorAll('#FacetsWrapperMobile .mobile-facets__list');
    if (!mobileLists.length) return;

    const updateLabelState = (labelEl, checked) => {
      if (!labelEl) return;
      labelEl.classList.toggle('active', checked);
      labelEl.setAttribute('aria-pressed', checked ? 'true' : 'false');
      // Toggle inner SVG dot visibility if present
      const dot = labelEl.querySelector('.facets__circle .facets__dot');
      if (dot) {
        dot.style.display = checked ? 'block' : 'none';
      }
      // Swatch inputs: label carries active, dot sits near input or inside label
      const swatchLabel = labelEl.classList.contains('swatch-input__label') ? labelEl : labelEl.querySelector('.swatch-input__label');
      if (swatchLabel) {
        swatchLabel.classList.toggle('active', checked);
      }
    };

    mobileLists.forEach((list) => {
      list.querySelectorAll('label.facets__label').forEach((label) => {
        const input = label.querySelector('input[type="checkbox"]');
        if (input) updateLabelState(label, input.checked);
      });

      if (list.__mobileFacetBound) return;
      list.addEventListener('change', (e) => {
        const input = e.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (input.type !== 'checkbox') return;
        const label = input.closest('label.facets__label, .swatch-input__label') || input.closest('label');
        updateLabelState(label, input.checked);
      });
      // Allow clicking anywhere on mobile swatch container to toggle (including unselect on second tap)
      list.addEventListener('click', (e) => {
        const container = e.target && e.target.closest ? e.target.closest('.mobile-facets__label') : null;
        if (!container) return;
        // If the container itself is a LABEL (text options), let native toggle handle it
        if (container.tagName && container.tagName.toLowerCase() === 'label') return;
        // Ignore interactive elements inside
        if (e.target.closest('a, button, input, select, textarea')) return;
        const input = container.querySelector('input[type="checkbox"]');
        if (!input) return;
        e.preventDefault();
        input.checked = !input.checked; // toggles off if currently active
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // Allow clicking on ring/dot to toggle the associated swatch checkbox without affecting siblings
      list.addEventListener('click', (e) => {
        const ringOrDot = e.target && e.target.closest ? e.target.closest('.facets__circle, .icon-checkmark-dot') : null;
        if (!ringOrDot) return;
        // Find nearest swatch input within the same item
        const item = ringOrDot.closest('.list-menu__item, .mobile-facets__item, .swatch-input-wrapper');
        if (!item) return;
        const input = item.querySelector('input[type="checkbox"].swatch-input__input');
        if (!input) return;
        // Prevent any default that might interfere and toggle explicitly
        e.preventDefault();
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      list.__mobileFacetBound = true;
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // Safely rebind mobile drawer events if present
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const menuDrawer = mobileForm.closest('menu-drawer');
      if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
        try {
          menuDrawer.bindEvents();
        } catch (_) {}
      }
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const targetForm = event.target && event.target.closest ? event.target.closest('form') : null;
    const isMobileForm = targetForm && targetForm.id === 'FacetFiltersFormMobile';
    if (isMobileForm) {
      // На мобільних чекбокси не застосовують фільтри миттєво – чекаємо Apply
      return;
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Global delegated handler to close filters drawer by clicking the Close title (survives re-renders)
if (!window.__plpFiltersTitleCloseBound) {
  document.addEventListener('click', function(e) {
    const closer = e.target && e.target.closest ? e.target.closest('.plp-filters-drawer__title--desktop') : null;
    if (!closer) return;
    const filtersDrawer = document.getElementById('filtersDrawer') || (closer.closest && closer.closest('#filtersDrawer'));
    if (!filtersDrawer) return;
    e.preventDefault();
    e.stopPropagation();
    filtersDrawer.classList.remove('active');
    if (window.innerWidth <= 1024) {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  });
  window.__plpFiltersTitleCloseBound = true;
}

// Global delegated Apply handler to reliably submit mobile filters via Section Rendering API
if (!window.__plpMobileApplyBound) {
  document.addEventListener('click', function(e) {
    const applyBtn = e.target && e.target.closest ? e.target.closest('#filtersDrawer .mobile-facets__footer .button--primary') : null;
    if (!applyBtn) return;
    e.preventDefault();
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const formData = new FormData(mobileForm);
      const searchParams = new URLSearchParams(formData).toString();
      FacetFiltersForm.renderPage(searchParams, null, true);
    }
    const filtersDrawer = document.getElementById('filtersDrawer');
    if (filtersDrawer) {
      filtersDrawer.classList.remove('active');
    }
    if (window.innerWidth <= 1024) {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  });
  window.__plpMobileApplyBound = true;
}

// Global delegated handler to close filters drawer by clicking the entire header (desktop only)
if (!window.__plpFiltersHeaderClickBound) {
  document.addEventListener('click', function(e) {
    const header = e.target && e.target.closest ? e.target.closest('.plp-filters-drawer__header') : null;
    if (!header) return;
    if (window.innerWidth <= 1024) return; // тільки desktop
    const filtersDrawer = document.getElementById('filtersDrawer') || (header.closest && header.closest('#filtersDrawer'));
    if (!filtersDrawer) return;
    e.preventDefault();
    e.stopPropagation();
    filtersDrawer.classList.remove('active');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  });
  window.__plpFiltersHeaderClickBound = true;
}
